import * as React from "react";
import * as styles from "./GlobalSearch.module.scss";
import Form from "react-bootstrap/Form";
import { IDates } from "./GlobalSearchProps";
import { useMobileDetectContext } from "../../../../context/MobileDetectContext";

export const Location: React.FC<any> = (props) => {
  return (
    <div className={`${styles.location} ${props.extraclass}`} {...props}>
      {props.children}
    </div>
  );
};

export const SearchForm: React.FC<any> = (props) => {
  return (
    <Form
      className={`global align-items-lg-center mb-0 ${styles.searchForm} ${
        props.isLogo ? "has-logo" : ""
      } ${
        props.isOfferModal
          ? `is-Offer-Modal`
          : ` h-100 ${styles.searchFormHotelSearchModal}`
      }`}
      onSubmit={props.onSubmit}
    >
      {props.children}
    </Form>
  );
};
export const Dates: React.FC<any> = React.forwardRef(
  (props: IDates, ref: any) => {
    const { isMobileOnly } = useMobileDetectContext();
    return (
      <div
        ref={ref}
        className={`${props.extraClass} ${
          props.isEditReservation ? `${styles.dates} dates` : ""
        }`}
      >
        {props.children}
      </div>
    );
  }
);

Dates.displayName = "Dates";

export const MemberDiscountList: React.FC<{
  children: JSX.Element | JSX.Element[];
}> = (props) => {
  return <ul className={styles.memberDiscountList}>{props.children}</ul>;
};

export const DropdownText: React.FC<{ discountToggleText: string }> = (
  props
) => {
  return (
    <span className={styles.dropdownText}>{props.discountToggleText}</span>
  );
};

export const OccupancyText: React.FC<{
  children: string | JSX.Element | JSX.Element[];
}> = (props) => {
  return <span className={styles.occupancyText}>{props.children}</span>;
};

export const useClickOutSide = (handler: { (): void; (): void }) => {
  const domNodeRef = React.useRef<HTMLInputElement>(null);
  React.useEffect(() => {
    const eventHandler: { (event: MouseEvent): void } = (event: MouseEvent) => {
      if (!domNodeRef.current?.contains(event.target as Node)) {
        handler();
      }
    };
    document.addEventListener("mousedown", eventHandler);
    return () => {
      document.removeEventListener("mousedown", eventHandler);
    };
  });
  return domNodeRef;
};
